import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, computed, effect, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from './Global';
import { MicrosoftAuthService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})

export class UserService {
   private _http = inject(HttpClient)
   private _authService = inject(MicrosoftAuthService)
   private url = Global.url_user
   private _token = this._authService.token()
   private _headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this._token);

  public userData = signal(null)
  public userPhoto = signal<string | null>(null)
  public sharingIdentity = signal({})
  public sharingEntity = signal({})
  public sharingEntities = signal<[]>([])
  public sharingLanguage = signal({})
  public sharingRole = signal({})
  public sharingMenu = signal<[]>([])
  public sharingMenuPath = signal({})

  processUserData(userData?: any) {
    if(userData) this.userData.set(userData)
  }

  processUserPhoto(arrayBuffer?: ArrayBuffer) {
    const url = this.arrayBufferToUrl(arrayBuffer);
    this.userPhoto.set(url)
  }

  private arrayBufferToUrl(arrayBuffer: ArrayBuffer): string {
    const array = new Uint8Array(arrayBuffer);
    const blob = new Blob([array], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  }

  getUsers(search?: string): Observable<any> {
    return this._http.get(this.url + `users/${search}`, { headers: this._headers });
  }

  updateUser(user: any) {
    return this._http.put(this.url + `users`, user, { headers: this._headers });
  }

  getRoles() {
    this._token = this._authService.token()
    this._headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this._token);
   return this._http.get(`${this.url}roles`, { headers: this._headers });
  }

  getMenus() {
    return this._http.get(this.url + `menus`, { headers: this._headers });
  }

  getMenuByRole(roleId: string) {
    return this._http.get(this.url + `menus/${roleId}`, { headers: this._headers });
  }

  updateMenu(menu: any) {
    return this._http.put(this.url + `menus`, menu, { headers: this._headers });
  }

  toggleMenuRole(roleId: string, menuId: string, enabled: boolean) {
    return this._http.put(this.url + `menus/toggle-role`, { roleId, menuId, enabled }, { headers: this._headers });
  }

  reorderMenus(menus: any[]) {
    return this._http.put(this.url + `menus/reorder`, menus, { headers: this._headers });
  }

  updateRole(role: any) {
    return this._http.put(this.url + `roles`, role, { headers: this._headers });
  }

}
